function Hero() {
  return (
    <section
      id="home"
      className="bg-[linear-gradient(160deg,#121d42,#1b2a5c_60%,#1c3a72)] pb-[100px] pt-[120px] text-center"
    >
      <div className="wrap">
        <div className="mx-auto max-w-[760px]">
          <p className="eyebrow">Venus Solutions Pvt Ltd</p>
          <h1 className="text-white">Your Business, Our Tech. A Perfect Match.</h1>
          <p className="mx-auto mb-9 mt-5 max-w-[560px] text-[1.15rem] text-white/80">
            We design and build websites and apps for businesses, and we build our own
            software products — including Invyntra, our inventory management platform.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a className="btn-primary" href="#products">
              Explore Our Products
            </a>
            <a className="btn-ghost" href="#contact">
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
